import * as types from './types';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  formValues: {
    branches: [],
    usersAllowed: [],
    availableCredits: {
      availablePlans: [],
      currentPlan: null,
      postingStatus: null,
      eligibleForUpgrade: false
    },
    comercialInfo: {},
    currentResponsible: null,
    currentBranch: null
  },
  commissionShare: 0,
  loadinFormValues: false,
  formValuesError: false,
  formValuesCompleted: false,
  isZonaDemandLocation: false
};

const publishReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_INITIALS_VALUES:
      return {
        ...state,
        loadinFormValues: true
      };
    case types.GET_INITIALS_VALUES_COMPLETED:
      return {
        ...state,
        formValues: {
          branches: action.payload.branches,
          usersAllowed: action.payload.userWithPermissions,
          commissionShare: action.payload.commissionShare,
          availableCredits: {
            availablePlans: action.payload['available-credits'].availablePlans,
            currentPlan: action.payload['available-credits'].currentPlan,
            postingStatus: action.payload['available-credits'].postingStatus,
            eligibleForUpgrade: action.payload['available-credits'].eligibleForUpgrade
          },
          comercialInfo: action.payload['commercial-info'],
          currentResponsible: action.payload.userWithPermissions?.find(user => user.isResponsible)?.userId || null,
          currentBranch: action.payload.branches?.find(branch => branch.isOwner)?.branchId || null
        },
        loadinFormValues: false,
        formValuesError: false,
        formValuesCompleted: true,
        isZonaDemandLocation: action.payload['zona_demand']
      };
    case types.GET_INITIALS_VALUES_FAILED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesError: isServiceError(action?.payload?.status)
      };
    case types.GET_CREDITS_OF_BRANCH:
      return {
        ...state,
        loadinFormValues: true
      };
    case types.GET_CREDITS_OF_BRANCH_FAILED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesError: isServiceError(action?.payload?.status)
      };
    case types.GET_CREDITS_OF_BRANCH_COMPLETED:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          usersAllowed: action.payload.userWithPermissions,
          availableCredits: {
            ...state.formValues.availableCredits,
            availablePlans: action.payload.availablePlans
          },
          comercialInfo: action.payload['commercial-info'] || {},
          currentResponsible:
            action.payload.userWithPermissions?.find(user => user.isResponsible)?.userId ||
            state.formValues.currentResponsible,
          currentBranch: state.formValues.currentBranch
        },
        loadinFormValues: false
      };
    case types.UPDATE_RESPONSIBLE:
      return {
        ...state,
        loadinFormValues: true,
        formValuesError: false,
        formValuesCompleted: false
      };
    case types.UPDATE_RESPONSIBLE_FAILED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesError: isServiceError(action?.payload?.status)
      };
    case types.UPDATE_RESPONSIBLE_COMPLETED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesCompleted: true
      };
    case types.UPDATE_BRANCH:
      return {
        ...state,
        loadinFormValues: true,
        formValuesError: false,
        formValuesCompleted: false
      };
    case types.UPDATE_BRANCH_FAILED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesError: isServiceError(action?.payload?.status)
      };
    case types.UPDATE_BRANCH_COMPLETED:
      return {
        ...state,
        loadinFormValues: false,
        formValuesCompleted: true
      };
    case types.UPDATE_SELECTED_PLAN:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          availableCredits: {
            ...state.formValues.availableCredits,
            currentPlan: {
              ...state.formValues.availableCredits.currentPlan,
              publication_plan_id: action.payload.planId
            }
          }
        }
      };
    case types.UPDATE_SELECTED_RESPONSIBLE:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          currentResponsible: action.payload.responsible
        }
      };
    case types.UPDATE_SELECTED_BRANCH:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          currentBranch: action.payload.branchId
        }
      };
    case types.UPDATE_COMMISSION_SHARE:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          commissionShare: action.payload.commissionShare
        }
      };
    case types.RESET_INFO:
      return { ...initialState };
    default:
      return state;
  }
};

export { publishReducer };
